/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2025-03-27 06:04:39.

export interface CollectionValueDto<V, T> {
    id: V;
    name: string;
    selected: boolean;
    disabled: boolean;
    payload: T;
}

export interface QuestionnaireScoreCategory extends BaseEntity, Comparable<QuestionnaireScoreCategory> {
    name: string;
    shortName: string;
    highScore: number;
    scoreLevel: AScoreLevel;
    scoreType: ScoreType;
    questionnaire: ComplianceQuestionnaire;
}

export interface BrandBrokerGroupsRequest {
    tradingAccountType: string;
    brokerCode: string;
    customerId: number;
}

export interface BundleProperty {
    name: string;
    key?: string;
    value?: string;
}

export interface CollectionRequest<T> {
    list: T[];
}

export interface CollectionResponse<T> {
    data: T[];
    totalCount: number;
}

export interface ConfigProperty {
    name: string;
    value: string;
}

export interface ConversionRateRequest {
    source: Currency;
    target: Currency;
}

export interface CustomerJointRequest {
    joints: number[];
    reason: string;
}

export interface CustomerMultiCompanyRequest {
    parentCustomerId: number;
    partnerCompanyId: number;
    affiliateId: string;
    termsAndConditionsAccepted: boolean;
}

export interface ECDDQuestionDto {
    id: number;
    name: string;
}

export interface EmailTemplateDefinitionDto {
    label: string;
    name: string;
}

/**
 * @deprecated for removal
 */
export interface EntityCreateForClassRequest extends EntityCreateRequest {
}

export interface EntityCreateRequest {
    className: string;
    properties: { [index: string]: any };
}

export interface EntityFilterElement {
    propertyName: string;
    comparisonOperator: ComparisonOperator;
    operands?: string[];
}

export interface EntityGridRowsRequest {
    startRow: number;
    endRow: number;
    sortModel?: SortModel;
    filterModel?: FilterModel;
    propertyNames: string[];
}

export interface EntityListElement {
    id: number;
    name: string;
}

export interface EntityListElementRequest {
    nameField: string;
}

export interface EntityQuery {
    id: number;
    entityClassName?: string;
    propertyNames: string[];
}

export interface EntityQueryWithCustomerID extends EntityQuery {
    customerId: number;
}

export interface EntityUpdateForClassRequest extends EntityUpdateRequest {
    className: string;
}

export interface EntityUpdateRequest {
    id: number;
    properties: { [index: string]: any };
}

export interface ExportGridRowRequest {
    language: string;
    timeZoneOffset?: number;
    startRow: number;
    endRow: number;
    sortModel?: SortModel;
    filterModel?: FilterModel;
    bundleProperties: BundleProperty[];
    format: ExportFormat;
    fileName: string;
    gridName: string;
}

export interface ExportNoteRowRequest extends ExportGridRowRequest {
    entityId: number;
    entityType: string;
    sectionName?: string;
}

export interface ExportObjectQuery {
    language: string;
    id: number;
    propertyNames: string[];
}

export interface ExportRawDataRequest {
    data: string[][];
    format: ExportFormat;
    fileName: string;
    timeZoneOffset?: number;
    gridName: string;
}

export interface FilterModel {
    elements: EntityFilterElement[];
}

export interface FullTextSearchRequest {
    search: string;
    filterModel?: FilterModel;
    propertyNames: string[];
}

export interface GetConfigPropertyRequest {
    properties: string[];
}

export interface NavigationMenu {
    menuId: string;
    children?: NavigationMenu[];
}

export interface NoteGridRowsRequest extends EntityGridRowsRequest {
    entityId: number;
    entityType: string;
    sectionName?: string;
}

export interface ObjectResponse<T> {
    data: T;
}

export interface PropertyHistoryQuery {
    entityName: string;
    entityId: number;
    entityProperties: string[];
    auditProperties: string[];
}

export interface ReportUrlRequest {
    id: number;
    from: number;
    to: number;
}

export interface SecretFieldsRequest {
    entityId: number;
    propertyNames: string[];
}

export interface SetConfigPropertyRequest {
    properties: ConfigProperty[];
}

export interface SortModel {
    sort: string;
    colId: string;
}

export interface StatEmailVerificationInfoRequest {
    startTime: number;
    endTime: number;
    countryCode: string;
}

export interface StatEmailVerificationInfoResponse {
    sendCount: number;
    sendUserCount: number;
    openCount: number;
    openUserCount: number;
    notOpenCount: number;
    notOpenUserCount: number;
    openRate: number;
    averageOpenTime: number;
}

export interface AvailableSubscriptionDto {
    id: number;
    type: string;
    name: string;
    defaultDuration: number;
}

export interface BaseAvailablePropertyValueDto {
    id: number;
    label: string;
}

export interface BuildInfoDto {
    "build.name": string;
    "build.version": string;
    "build.number": string;
    "build.branch": string;
    "build.commit": string;
    "build.date": string;
}

export interface ConversionRateResponse {
    source: Currency;
    target: Currency;
    rate: number;
}

export interface CountryPayloadDto {
    eeaCountry: boolean;
    forbiddenJurisdiction: boolean;
    dbValue: string;
}

export interface CurrentUserDto {
    id: number;
    loginName: string;
    stageName: string;
    fullName: string;
    title: string;
    userInfo: UserInfoDto;
}

export interface CustomerDto {
    id: number;
    firstName: string;
    lastName: string;
}

export interface DefaultEntityDto {
    id: number;
    type: string;
    name: string;
}

export interface ForgetCustomerResponseDto {
    customerId: number;
    vamosNotifiedProperly: boolean;
    cosmosNotifiedProperly: boolean;
    isVamosNotifiedProperly: boolean;
    isCosmosNotifiedProperly: boolean;
}

export interface LogDto {
    level: Level;
    message: string;
}

export interface PermissionsDto {
    disallowed: { [index: string]: string[] };
}

export interface PhoneDto {
    label: string;
}

export interface QuestionnaireGroupDto {
    id: number;
    name: string;
    title: string;
    userApproval: boolean;
    position: number;
    numberOfColumns: number;
}

export interface QuestionnaireScoreCategoryDto {
    name: string;
    shortName: string;
    scoreLevel: AScoreLevel;
    highScore: number;
}

export interface TaskAssignmentDto {
    toMe: boolean;
    toCustomerAssignee: boolean;
}

export interface UpdateEntityResponse {
    modificationTime: Date;
}

export interface UserDto {
    id: number;
    loginName: string;
    stageName: string;
    fullName: string;
    title: string;
}

export interface UserInfoDto {
    pendingDocuments: number;
    pendingDeposits: number;
    assignedTasks: number;
    oldestDocument: Date;
}

export interface BaseTransactionSearchResultDto extends SearchResultDto {
    firstName: string;
    lastName: string;
    subType: TransactionKind;
    externalId: string;
    currency: Currency;
    amount: number;
    deposit?: boolean;
    status: TransactionStatus;
}

export interface BaseTransactionSearchResultDtoBuilderImpl {
}

export interface CustomerDocumentSearchResultDto extends SearchResultDto {
    name: string;
    firstName: string;
    lastName: string;
    status: DocumentStatus;
}

export interface CustomerDocumentSearchResultDtoBuilderImpl {
}

export interface CustomerSearchResultDto extends SearchResultDto {
    firstName: string;
    lastName: string;
    registrationStatus: CustomerRegistrationStatus;
    complianceStage: ComplianceStage;
    brand: string;
}

export interface CustomerSearchResultDtoBuilderImpl {
}

export interface DefaultSearchResultDto extends SearchResultDto {
    label: string;
}

export interface DefaultSearchResultDtoBuilderImpl {
}

export interface SearchResultDto {
    id: string;
    type: string;
    creationTime: number;
}

export interface SearchResultDtoBuilderImpl {
}

export interface TradingAccountSearchResultDto extends SearchResultDto {
    platformAccountId: string;
    currency: Currency;
    firstName: string;
    lastName: string;
    equity: number;
    instrumentType: TradingAccountInstrumentType;
    tradingAccountType: TradingAccountType;
}

export interface TradingAccountSearchResultDtoBuilderImpl {
}

export interface UserSearchResultDto extends SearchResultDto {
    fullName: string;
    loginName: string;
    title: string;
    status: UserStatus;
}

export interface UserSearchResultDtoBuilderImpl {
}

export interface MandatoryDescriptors {
}

/**
 * @deprecated for removal
 */
export interface BankAccountCreateMandatoryProps {
}

export interface CosmosTradingAccountCreateMandatoryProps {
}

export interface CosmosTradingAccountUpdateMandatoryProps {
}

/**
 * @deprecated for removal
 */
export interface CreditCardCreateMandatoryProps {
}

/**
 * @deprecated for removal
 */
export interface CreditCardUpdateMandatoryProps {
}

export interface MT4TradingAccountCreateMandatoryProps {
}

export interface MT4TradingAccountUpdateMandatoryProps {
}

export interface MT5TradingAccountCreateMandatoryProps {
}

export interface MT5TradingAccountUpdateMandatoryProps {
}

export interface TTATradingAccountCreateMandatoryProps {
}

export interface TTATradingAccountUpdateMandatoryProps {
}

export interface AuthRequest {
    userName: string;
    password: string;
    newPassword?: string;
    otpCode?: string;
}

export interface AuthResponse {
    accessToken: string;
    refreshToken: string;
}

export interface CompletedFileExportEvent extends SSEEvent<EventExportFile> {
    payload: EventExportFile;
}

export interface ErrorExportEvent extends SSEEvent<string> {
    payload: string;
}

export interface EventExportFile {
    fileName: string;
    format: string;
    hash: string;
}

export interface PingEvent extends SSEEvent<string> {
    payload: string;
}

export interface SSEEvent<E> {
    id: string;
    payload: E;
}

export interface StartFileExportEvent extends SSEEvent<EventExportFile> {
    payload: EventExportFile;
}

export interface ComplianceQuestionnaire extends BaseEntity {
    name: string;
    questions: QuestionnaireQuestion[];
    staticQuestions: QuestionnaireStaticQuestion[];
    scoreCategories: QuestionnaireScoreCategory[];
    groups: QuestionnaireGroup[];
    scoreCalculator: string;
    govScoreCalculator: string;
    deleted: boolean;
    questionnaireType: QuestionnaireType;
    productType: ProductType;
    groupsView: boolean;
    synthetic: boolean;
    supportedProducts: TradingAccountInstrumentType[];
    brands: Brand[];
    activeQuestions: QuestionnaireQuestion[];
    sortedScoreCategories: QuestionnaireScoreCategory[];
    sortedGroups: QuestionnaireGroup[];
}

export interface BaseEntity extends BaseDTO, EntityDTO, SearchableObject<number>, Serializable {
    creationTime: Date;
    description: string;
    modificationTime: Date;
    createdBy: string;
    modifiedBy: string;
    searchKey: number;
}

export interface QuestionnaireQuestion extends BaseEntity {
    name: string;
    questionnaire: ComplianceQuestionnaire;
    group: QuestionnaireGroup;
    numPossibleAnswers: number;
    possibleAnswers: QuestionnaireAnswer[];
    inactive: boolean;
    shortName: string;
    mandatory: boolean;
    hidden: boolean;
    position: number;
    questionnaireQuestionType: QuestionnaireQuestionType;
    questionnaireQuestionValidator: QuestionnaireQuestionValidator;
    notEmpty: boolean;
    span: number;
    derivingAnswers: QuestionnaireQuestionDerivingAnswer[];
    activePossibleAnswers: QuestionnaireAnswer[];
}

export interface QuestionnaireStaticQuestion extends BaseEntity {
    questionnaire: ComplianceQuestionnaire;
    name: string;
    shortName: string;
    ognlPath: string;
    position: number;
    group: QuestionnaireGroup;
    mandatory: boolean;
    notEmpty: boolean;
    hidden: boolean;
    inactive: boolean;
    questionnaireQuestionType: QuestionnaireStaticQuestionType;
    questionnaireQuestionValidator: QuestionnaireStaticQuestionValidator;
}

export interface QuestionnaireGroup extends BaseEntity, Comparable<QuestionnaireGroup> {
    title: string;
    name: string;
    questionnaire: ComplianceQuestionnaire;
    questions: QuestionnaireQuestion[];
    userApproval: boolean;
    position: number;
    numberOfColumns: number;
}

export interface ProductType extends BaseEntity {
    name: string;
}

export interface Brand extends BusinessDomain {
    company: Company;
    domain: string;
    offline: boolean;
    deleted: boolean;
    brandConfiguration: BrandConfiguration;
    businessGroup: BusinessGroup[];
    configurationProperties: { [index: string]: any };
    defaultBusinessGroup: BusinessGroup;
}

export interface BaseDTO extends DTO, Serializable {
}

export interface EntityDTO extends DTO {
    version: number;
    id: number;
    type: string;
}

export interface Serializable {
}

export interface Comparable<T> {
}

export interface QuestionnaireAnswer extends BaseEntity {
    question: QuestionnaireQuestion;
    score: number;
    govScore: number;
    name: string;
    inactive: boolean;
    shortName: string;
    position: number;
    hasOtherOption: boolean;
    derivingAnswers: QuestionnaireAnswerDerivingAnswer[];
}

export interface QuestionnaireQuestionDerivingAnswer extends BaseEntity, IQuestionAware {
    questionId: number;
    answer: QuestionnaireAnswer;
    strategy: QuestionnaireQuestionDerivingStrategy;
}

export interface Company extends BaseEntity {
    name: string;
}

export interface BrandConfiguration extends BaseEntity {
    brand: Brand;
    passwordValidationEnabled: boolean;
    passwordExpirationDays: number;
    passwordHistoryEnforced: boolean;
    passwordUsernameRestricted: boolean;
    passwordMaxFailedAttempts: number;
    passwordLockOnFailedAttemptsMinutes: number;
    passwordMinLength: number;
    passwordMaxLength: number;
    passwordSpecialSymbolsRequired: boolean;
    passwordSpecialSymbols: string;
    passwordNumericsRequired: boolean;
    passwordUpperCaseRequired: boolean;
    passwordLowerCaseRequired: boolean;
    passwordForceChangeOnExpirationEnabled: boolean;
    maxCaptchaFailedLogins: number;
    loginCaptchaRequired: number;
    commonlyUsedPasswords: boolean;
}

export interface BusinessGroup extends BaseEntity {
    name: string;
    brand: Brand;
    defaultFlag: boolean;
    deleted: boolean;
}

export interface BusinessDomain extends BaseEntity {
    discriminator: number;
    name: string;
    displayName: string;
    prefix: string;
}

export interface DTO {
}

export interface SearchableObject<T> {
    searchKey: T;
}

export interface QuestionnaireAnswerDerivingAnswer extends BaseEntity, IQuestionAware {
    answerId: number;
    answer: QuestionnaireAnswer;
    strategy: QuestionnaireAnswerDerivingStrategy;
}

export interface IQuestionAware {
    question: QuestionnaireQuestion;
}

export enum ExportFormat {
    CSV = "CSV",
    XLSX = "XLSX",
}

export enum Level {
    INFO = "INFO",
    DEBUG = "DEBUG",
    ERROR = "ERROR",
}

export enum AScoreLevel {
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
}

export enum ScoreType {
    APPROPRIATENESS_SCORE = "APPROPRIATENESS_SCORE",
    GOVERNANCE_SCORE = "GOVERNANCE_SCORE",
}

export enum Currency {
    USD = "USD",
    EUR = "EUR",
    GBP = "GBP",
    CAD = "CAD",
    JPY = "JPY",
    AED = "AED",
    PLN = "PLN",
    AZN = "AZN",
    INR = "INR",
    NZD = "NZD",
    CUP = "CUP",
    EGP = "EGP",
    LBP = "LBP",
    RMB = "RMB",
    AUD = "AUD",
    ILS = "ILS",
    RON = "RON",
    CHF = "CHF",
    CZK = "CZK",
    DKK = "DKK",
    RUB = "RUB",
    BGN = "BGN",
    HRK = "HRK",
    CNY = "CNY",
    MXN = "MXN",
    CLP = "CLP",
    ALL = "ALL",
    NOK = "NOK",
    SEK = "SEK",
    HUF = "HUF",
    BRL = "BRL",
    ZAR = "ZAR",
    HKD = "HKD",
    SGD = "SGD",
    THB = "THB",
    TRY = "TRY",
    KRW = "KRW",
    SKK = "SKK",
    LKR = "LKR",
    COP = "COP",
    VND = "VND",
    CNH = "CNH",
    SAR = "SAR",
    MYR = "MYR",
    USDT = "USDT",
    LOCAL_CURRENCY = "LOCAL_CURRENCY",
}

export enum ComparisonOperator {
    Equals = "Equals",
    NotEquals = "NotEquals",
    LessThan = "LessThan",
    LessThanOrEq = "LessThanOrEq",
    GreaterThan = "GreaterThan",
    GreaterThanOrEq = "GreaterThanOrEq",
    In = "In",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    Between = "Between",
    Like = "Like",
    NotIn = "NotIn",
    IsNull = "IsNull",
    IsNotNull = "IsNotNull",
    Contains = "Contains",
    NotContains = "NotContains",
    ContainsAny = "ContainsAny",
}

export enum TransactionKind {
    NEGATIVE_ADJUSTMENT = "NEGATIVE_ADJUSTMENT",
    NEGATIVE_DEALING_CORRECTION = "NEGATIVE_DEALING_CORRECTION",
    NEGATIVE_FRAUD_ADJUSTMENT = "NEGATIVE_FRAUD_ADJUSTMENT",
    NEGATIVE_BONUS_ADJUSTMENT = "NEGATIVE_BONUS_ADJUSTMENT",
    CLOSING_ACCOUNT_BOOK_NEGATIVE = "CLOSING_ACCOUNT_BOOK_NEGATIVE",
    PARTNER_NEGATIVE_ADJUSTMENT = "PARTNER_NEGATIVE_ADJUSTMENT",
    POSITIVE_ADJUSTMENT = "POSITIVE_ADJUSTMENT",
    POSITIVE_DEALING_CORRECTION = "POSITIVE_DEALING_CORRECTION",
    POSITIVE_FRAUD_ADJUSTMENT = "POSITIVE_FRAUD_ADJUSTMENT",
    POSITIVE_BONUS_ADJUSTMENT = "POSITIVE_BONUS_ADJUSTMENT",
    CLOSING_ACCOUNT_BOOK_POSITIVE = "CLOSING_ACCOUNT_BOOK_POSITIVE",
    PARTNER_PAYMENT = "PARTNER_PAYMENT",
    PARTNER_BONUS = "PARTNER_BONUS",
    BONUS = "BONUS",
    CREDIT_CARD_DEPOSIT = "CREDIT_CARD_DEPOSIT",
    WIRE_TRANSFER_DEPOSIT = "WIRE_TRANSFER_DEPOSIT",
    CREDIT_CREDIT_CARD_WITHDRAWAL = "CREDIT_CREDIT_CARD_WITHDRAWAL",
    VOID_CREDIT_CARD_WITHDRAWAL = "VOID_CREDIT_CARD_WITHDRAWAL",
    REFUND_CREDIT_CARD_WITHDRAWAL = "REFUND_CREDIT_CARD_WITHDRAWAL",
    WIRE_TRANSFER_WITHDRAWAL = "WIRE_TRANSFER_WITHDRAWAL",
    MANUAL_DEPOSIT = "MANUAL_DEPOSIT",
    INTERNAL_DEPOSIT = "INTERNAL_DEPOSIT",
    MANUAL_WITHDRAWAL = "MANUAL_WITHDRAWAL",
    INTERNAL_WITHDRAWAL = "INTERNAL_WITHDRAWAL",
    LIBERTY_RESERVE_DEPOSIT = "LIBERTY_RESERVE_DEPOSIT",
    LIBERTY_RESERVE_WITHDRAWAL = "LIBERTY_RESERVE_WITHDRAWAL",
    ENVOY_DEPOSIT = "ENVOY_DEPOSIT",
    ENVOY_WITHDRAWAL = "ENVOY_WITHDRAWAL",
    WM_WITHDRAWAL = "WM_WITHDRAWAL",
    NETELLER_DEPOSIT = "NETELLER_DEPOSIT",
    MONEYBOOKERS_DEPOSIT = "MONEYBOOKERS_DEPOSIT",
    QIWI_DEPOSIT = "QIWI_DEPOSIT",
    WEBMONEY_DEPOSIT = "WEBMONEY_DEPOSIT",
    CHINAUNION_DEPOSIT = "CHINAUNION_DEPOSIT",
    CUP_DEPOSIT = "CUP_DEPOSIT",
    CHINAUNION_WITHDRAWAL = "CHINAUNION_WITHDRAWAL",
    LOBANET_DEPOSIT = "LOBANET_DEPOSIT",
    QIWI_WITHDRAWAL = "QIWI_WITHDRAWAL",
    PSP_DEPOSIT = "PSP_DEPOSIT",
    BAOFOO_DEPOSIT = "BAOFOO_DEPOSIT",
    SOLIDPAY_DEPOSIT = "SOLIDPAY_DEPOSIT",
    FOCAL_DEPOSIT = "FOCAL_DEPOSIT",
    PAYGATE_DEPOSIT = "PAYGATE_DEPOSIT",
    PAYMENT_ASIA_DEPOSIT = "PAYMENT_ASIA_DEPOSIT",
    CRYPTO_WITHDRAWAL = "CRYPTO_WITHDRAWAL",
    MD_APM_WITHDRAWAL = "MD_APM_WITHDRAWAL",
}

export enum TransactionStatus {
    PENDING = "PENDING",
    PENDING_COMPLIANCE = "PENDING_COMPLIANCE",
    DONE = "DONE",
    FAILED = "FAILED",
    REJECTED = "REJECTED",
    PENDING_PM_APPROVAL = "PENDING_PM_APPROVAL",
    CANCELLED_PENDING_PM_APPROVAL = "CANCELLED_PENDING_PM_APPROVAL",
    CANCELLED_PENDING_COMPLIANCE = "CANCELLED_PENDING_COMPLIANCE",
}

export enum DocumentStatus {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    EXPIRED = "EXPIRED",
    INPROCCESS = "INPROCCESS",
    PENDING_EXPIRATION = "PENDING_EXPIRATION",
}

export enum CustomerRegistrationStatus {
    LEAD = "LEAD",
    DEMO = "DEMO",
    REAL = "REAL",
    REAL_FUNDED = "REAL_FUNDED",
}

export enum ComplianceStage {
    NON_COMPLIANT = "NON_COMPLIANT",
    COMPLIANT = "COMPLIANT",
    PENDING_COMPLIANCE = "PENDING_COMPLIANCE",
    LIMITED_COMPLIED = "LIMITED_COMPLIED",
    COMPLIANCE_REVOKED = "COMPLIANCE_REVOKED",
    COMPLIANCE_SUSPENDED = "COMPLIANCE_SUSPENDED",
}

export enum TradingAccountInstrumentType {
    CFD = "CFD",
    SPREAD_BETTING = "SPREAD_BETTING",
    QUANT_RANKS = "QUANT_RANKS",
    SHARE_DEALING = "SHARE_DEALING",
    ASSET_MANAGEMENT = "ASSET_MANAGEMENT",
    CRYPTO = "CRYPTO",
}

export enum TradingAccountType {
    REAL = "REAL",
    DEMO = "DEMO",
}

export enum UserStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export enum QuestionnaireType {
    COMPLIANCE = "COMPLIANCE",
    AML = "AML",
    EPA = "EPA",
    FULL_CUSTOMER_REGISTRATION = "FULL_CUSTOMER_REGISTRATION",
    ADDITIONAL_REGISTRATION = "ADDITIONAL_REGISTRATION",
    PRODUCT = "PRODUCT",
}

export enum QuestionnaireQuestionType {
    NONE = "NONE",
    LABEL = "LABEL",
    EDIT_TEXT = "EDIT_TEXT",
    EDIT_TEXT_AREA = "EDIT_TEXT_AREA",
    LIST = "LIST",
    CHECKBOX = "CHECKBOX",
    MULTI_CHECKBOX = "MULTI_CHECKBOX",
    RADIO = "RADIO",
    HORIZONTAL_RADIO = "HORIZONTAL_RADIO",
    DATE = "DATE",
    DATETIME = "DATETIME",
    PHONE = "PHONE",
    EMAIL = "EMAIL",
    COUNTRY = "COUNTRY",
    PASSWORD = "PASSWORD",
    CURRENCY = "CURRENCY",
    MULTISELECT_ALL = "MULTISELECT_ALL",
    MULTISELECT_NONE = "MULTISELECT_NONE",
    MULTISELECT_ALL_NONE = "MULTISELECT_ALL_NONE",
    ALLOWED_COUNTRIES = "ALLOWED_COUNTRIES",
}

export enum QuestionnaireQuestionValidator {
    NOT_SPECIFIED = "NOT_SPECIFIED",
    BIRTHDAY = "BIRTHDAY",
    TIN = "TIN",
    NOT_USER_COUNTY = "NOT_USER_COUNTY",
    NCI = "NCI",
    TIN2 = "TIN2",
}

export enum QuestionnaireStaticQuestionType {
    NONE = "NONE",
    EDIT_TEXT = "EDIT_TEXT",
    EMAIL = "EMAIL",
    PASSWORD = "PASSWORD",
    PHONE = "PHONE",
    DATE = "DATE",
    COUNTRY = "COUNTRY",
    CITIZENSHIP = "CITIZENSHIP",
    LANGUAGE = "LANGUAGE",
    CHECKBOX = "CHECKBOX",
}

export enum QuestionnaireStaticQuestionValidator {
    NOT_SPECIFIED = "NOT_SPECIFIED",
    NAME = "NAME",
    BIRTHDAY = "BIRTHDAY",
    ADDRESS = "ADDRESS",
    CITY = "CITY",
    ZIP_CODE = "ZIP_CODE",
}

export enum QuestionnaireQuestionDerivingStrategy {
    HIDE = "HIDE",
    DISABLE = "DISABLE",
    SHOW = "SHOW",
}

export enum QuestionnaireAnswerDerivingStrategy {
    HIDE = "HIDE",
    SHOW = "SHOW",
}
